import script from "./modal_add.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_add.vue?vue&type=script&setup=true&lang=ts"

import "./modal_add.vue?vue&type=style&index=0&id=c8f51d58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f51d58"]])

export default __exports__